import React from 'react';
import { NavLink } from 'react-router-dom';
import { logout } from '../Services/Api.service';
import { translate } from '../../Services/translation';
import { BACKEND_LOGGEND_IN_ONLYECOM } from '../Services/Api.service';

export const Navigation = props => {
    const { isLoggedIn } = props;
    const onlyEcom = localStorage.getItem(BACKEND_LOGGEND_IN_ONLYECOM) === "true";

    return (
        <nav className="backend__nav">
            <div className="top-bar">
                <div className="top-bar-left">
                    <ul className="menu">
                        <li className="menu-text">{translate("coptikk.adminportal.backoffice.header")}</li>
                        {isLoggedIn && <>                            
                            {!onlyEcom && <li>
                                <NavLink to="/articles">{translate("coptikk.adminportal.navigation.articles")}</NavLink>
                            </li>}
                            {!onlyEcom && <li>
                                <NavLink to="/employees">{translate("coptikk.adminportal.navigation.employees")}</NavLink>
                            </li>}
                            {!onlyEcom && <li>
                                <NavLink to="/settings">{translate("coptikk.adminportal.navigation.settings")}</NavLink>
                            </li>}   
                            <li>
                                <NavLink to="/ecommercelanding">{translate("coptikk.adminportal.navigation.ecommerce")}</NavLink>
                            </li>                         
                        </>}
                    </ul>
                </div>
                {isLoggedIn && <div className="top-bar-right">
                    <ul className="menu">
                        <li>
                            <button type="button" className="button" onClick={() => { logout() }}>
                                {translate("coptikk.adminportal.button.logout")}
                            </button>
                        </li>
                    </ul>
                </div>}
            </div>
        </nav>
    );
}